import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useEditWorkspaceName } from 'hooks/useEditWorkspaceName';

export const WorkspaceEditComponent = (props: { currentName: string, onClose: () => void; onActionSuccess: () => void; open: boolean }) => {
    const [name, setName] = useState(props.currentName);
    const { t } = useTranslation();
    const { editWorkspaceName, editingWorkspaceName } = useEditWorkspaceName();

    const handleEditWorkspace = async () => {
        const resp = await editWorkspaceName({ name });
        if (resp?.success) {
            props.onActionSuccess();
            props.onClose();
        }
    }

    useEffect(() => {
        setName(props.currentName);
    }, [props.currentName])

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>{t('admin.editWorkspace')}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label={t('admin.workspaceName')}
                    type="text"
                    fullWidth
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>{t('admin.cancel')}</Button>
                <LoadingButton loading={editingWorkspaceName} onClick={handleEditWorkspace}>{t('admin.edit')}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};